import * as Yup from "yup";
import { ListGroup } from "react-bootstrap";
import { FormModal } from "../../../Forms/FormModal";
import { BaseKpoForm } from "./KpoReceiveConfirmation";
import { useKeoCardsSearch } from "../../../Bdo/Keo/useKeoCardsSearch";
import { useEffect } from "react";
import { KeoBdoCodeSelect } from "../../../Bdo/Keo/KeoBdoCodeSelect";
import { NumericControl } from "../../../Forms/NumericControl";
import { HorizontalView } from "../../../Abstractions/HorizontalView";
import { FormControl } from "../../../Forms/FormControl";
import { KPO_STATUS } from "../../../../domain/KpoCardStatus";
import { KeoCardDescriptionProvider } from "../../../Bdo/Keo/KeoCardDescriptionProvider";
import { dateToString } from "../../../../domain/Configuration";

export function GenerateKeoRecordsFromKpoCards({ kpoCards, onSubmit, name, promptTitle, performAll }) {
  // const { validate } = ValidateBdoAction();
  const { items: keoItems, onSearchChange } = useKeoCardsSearch();
  const { formControls, defaultValues, validationSchema } = KpoToKeoFormProvider({ kpoCards, keoItems });

  const handleSubmit = async(payload) => {
    const kpoItems = payload.kpoItems.filter(x => x.isSelected).map((x) => ({
      kpoId: x.kpoId,
      keoId: x.keoItem.keoId
    }));

    // validate(kpoItems);
    await onSubmit(kpoItems);
  };

  useEffect(() => {
    onSearchChange(null);
  }, []);


  return <FormModal
    title={promptTitle}
    formControls={formControls}
    defaultValues={defaultValues}
    onSubmit={handleSubmit}
    buttonText={name}
    validationSchema={validationSchema}
    isButtonTrigger={performAll}
    skipToast
    sizeModal="md"
    submitBtnText={name}/>;
}

function KpoToKeoControl({ kpoItem, selectable, parentName, keoItems }) {
  const keoItemControlName = `${parentName}.keoItem`;

  const formControls =  <div className="domain-control">
    <KeoBdoCodeSelect name={keoItemControlName} kpoCardWasteCode={kpoItem.wasteCode} keoItems={keoItems} />
    <HorizontalView>
      <FormControl name={`${parentName}.collectionTime`} label="Data przejęcia" inputType="date" readonly/>
      <NumericControl name={`${parentName}.wasteMass`} decimalPlaces={4} label="Przyjęta masa odpadów [Mg]" readonly/>
    </HorizontalView>
  </div>;

  return <BaseKpoForm kpoItem={kpoItem} selectable={selectable} formControls={formControls} parentName={parentName}/>;
}

export function KpoToKeoFormProvider({ kpoCards, keoItems }) {
  const kpoItemSchema = Yup.object().shape({
    cardNumber: Yup.string().required("Numer karty jest wymagany"),
    keoItem: Yup.object().nullable().when("isSelected", {
      is: true,
      then: Yup.object().nullable().required("Karta KEO jest wymagana")
    }),
    collectionTime: Yup.date().nullable().when("isSelected", {
      is: true,
      then: Yup.date().nullable().required("Data przejęcia jest wymagana")
    })
  });

  const validationSchema = Yup.object().shape({
    kpoItems: Yup.array().of(kpoItemSchema)
  });

  const filteredKpoCards = kpoCards.filter(x => !x.keoEntryId && (x.status === KPO_STATUS.RECEIVE_CONFIRMATION || x.status === KPO_STATUS.TRANSPORT_CONFIRMATION));

  const values = filteredKpoCards.map(x => {
    return (
      {
        kpoId: x.kpoId,
        cardNumber: x.cardNumber,
        wasteMass: x.wasteMass?.toFixed(4),
        wasteCode: x.wasteCode,
        wasteCodeId: x.wasteCodeId,
        keoItem: getDefaultKeoItem(x, keoItems),
        collectionTime: dateToString(x.collectionTime),
        isSelected: true
      });
  });

  const defaultValues = { kpoItems: values };
  const formControls =
    <div>
      {values.length === 0 && <ListGroup.Item>Brak kart KPO do wygenerowania KEO</ListGroup.Item>}
      {filteredKpoCards.map((x, idx) =>
        <div key={idx}>
          <KpoToKeoControl kpoItem={x} selectable={filteredKpoCards.length > 1} parentName={`kpoItems[${idx}]`} keoItems={keoItems} />
        </div>)}
    </div>;

  return { validationSchema, formControls, defaultValues };
}

const getDefaultKeoItem = (kpoItem, keoItems) => {
  const keoItem = keoItems.find(x => x.year === kpoItem.year && x.wasteCode.includes(kpoItem.wasteCode));
  if (keoItem) {
    return {
      keoId: keoItem.keoId,
      description: KeoCardDescriptionProvider.getDescription(keoItem)
    };
  }

  return null;
};